export const profile = {
  name: "Bunny",
  logo: "fw.",
  email: "bunny@theaibunny.com",
  calendly: "https://calendly.com/0x0bunny/30min",
  roles: ["Blockchain Engineer", "Rust Developer", "CTO", "Systems Architect"],
  roleLine: { prefix: "A ", suffix: " bridging TradFi and DeFi." },
  description:
    "Building secure blockchain infrastructure for institutional custody, tokenization, and digital asset markets.",
  networks: [
    { name: "Bitcoin", icon: "/networks/bitcoin.svg", mark: "bitcoin", highlight: "Multisig custody with hot and cold key separation" },
    { name: "EVM", icon: "/networks/evm.svg", mark: "ethereum", highlight: "Ethereum node operations, zkTLS oracles, orderbooks, CMTAT and T-REX tokenization, compliance" },
    { name: "Canton", icon: "/networks/canton.jpg", mark: "canton", highlight: "Validator nodes, DAR deployment, DAML securities and derivatives contracts, multisig custody" },
    { name: "Solana", icon: "/networks/solana.svg", mark: "solana", highlight: "Multisig custody in the Rust wallet stack, compliant tokenization" },
    { name: "Stellar", icon: "/networks/stellar.svg", mark: "stellar", highlight: "Institutional settlement infrastructure, plus asset issuance" },
    { name: "IOTA", icon: "/networks/iota.jpg", mark: "iota", highlight: "Compliant tokenization, multisig custody, transaction orchestration" },
    { name: "Monero", icon: "/networks/monero.svg", mark: "monero", highlight: "Hot and cold wallet custody with segregated key storage" },
  ],
  whitepaperUrl: "https://github.com/0xsereel/whitepaper/blob/main/surreal.pdf",
  socials: [
    { name: "GitHub", url: "https://github.com/aibunny" },
    { name: "Twitter", url: "https://twitter.com/theaibunny" },
    { name: "LinkedIn", url: "https://www.linkedin.com/in/waihenya-/" },
  ],
};

export const loadingWords = ["Build", "Secure", "Scale"];

export const works = [
  {
    title: "Agent SSH",
    desc: "Brokered SSH access for AI agents: credentials stay behind the broker with full command output, approvals, and auditable remote actions.",
    tech: "Rust · SSH · Security · AI Agents",
    url: "https://aibunny.github.io/agent-ssh/",
    img: "https://images.unsplash.com/photo-1555066931-4365d14bab8c?w=1200&q=80&auto=format&fit=crop",
    span: "md:col-span-7",
    aspect: "aspect-[4/3] md:aspect-[16/10]",
  },
  {
    title: "Rusty Telescope",
    desc: "A Rust node exporter for precise measurement of machine resources: memory, disk, and CPU utilization for observability stacks.",
    tech: "Rust · Observability · Systems",
    url: "https://github.com/aibunny/telescope-rust",
    img: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=1200&q=80&auto=format&fit=crop",
    span: "md:col-span-5",
    aspect: "aspect-[4/3] md:aspect-[16/13]",
  },
  {
    title: "Sereel Whitepaper",
    desc: "Co-authored institutional DeFi whitepaper: unified AMM, peer-to-peer lending, and options trading framework for compliant execution.",
    tech: "DeFi · AMM · Lending · Derivatives",
    url: "https://github.com/0xsereel/whitepaper/blob/main/surreal.pdf",
    img: "https://images.unsplash.com/photo-1642104704074-907c0698cbd9?w=1200&q=80&auto=format&fit=crop",
    span: "md:col-span-5",
    aspect: "aspect-[4/3] md:aspect-[16/13]",
  },
  {
    title: "Multichain Custody Infra",
    desc: "Multisig custody infrastructure in Rust: Bitcoin, EVM chains, Solana, IOTA, and Canton with secure key management.",
    tech: "Rust · Bitcoin · EVM · Solana · Canton",
    url: "https://www.sereel.com/",
    img: "https://images.unsplash.com/photo-1639762681485-074b7f938ba0?w=1200&q=80&auto=format&fit=crop",
    span: "md:col-span-7",
    aspect: "aspect-[4/3] md:aspect-[16/10]",
  },
];

export const journal = [
  {
    slug: "sovereign-ai-state",
    title: "A Sovereign AI State",
    desc: "Your model provider should be replaceable. Your accumulated intelligence should be an asset you own.",
    date: "Jun 2026",
    readTime: "7 min read",
    xUrl: "https://x.com/TheAIbunny/status/2089831505715413061",
    img: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=1200&q=80&auto=format&fit=crop",
  },
  {
    slug: "cmtat-trex-convergence",
    title: "CMTAT and T-REX: Converging Infrastructure for Institutional Tokenization",
    desc: "How two regulated-tokenization frameworks are technically converging, and what that means for issuers.",
    date: "Jun 21, 2026",
    readTime: "18 min read",
    xUrl: "https://x.com/TheAIbunny/status/2068753987965235643",
    img: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=1200&q=80&auto=format&fit=crop",
  },
  {
    slug: "institutions-onchain",
    title: "Institutions Were Never Coming Onchain Like This",
    desc: "Privacy is not anti-decentralization. It's the prerequisite for institutional participation.",
    date: "Mar 28, 2026",
    readTime: "4 min read",
    xUrl: "https://x.com/TheAIbunny/status/2037685476010692807?s=20",
    img: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1200&q=80&auto=format&fit=crop",
  },
];

// Optional hero video. Drop an MP4 (and optionally a WebM) into public/video/
// and set the path here; the still image stays as poster and reduced-motion fallback.
export const heroVideo = { mp4: null, webm: null };

export const HLS_SRC = "https://stream.mux.com/Aa02T7oM1wH5Mk5EEVDYhbZ1ChcdhRsS2m1NYyx4Ua1g.m3u8";

export const experience = [
  {
    title: "Co-Founder & CTO",
    company: "Sereel",
    url: "https://www.sereel.com/",
    location: "Remote",
    range: "September 2024 – Present",
    bullets: [
      "Architect and deploy ERC-3643 (T-REX) and CMTAT compliant security token contracts with OnchainID identity management for compliance and KYC/AML requirements.",
      "Design and maintain Sereel's technical architecture, from blockchain infrastructure to backend microservices, API gateways, and user-facing systems.",
      "Engineer DAML smart contracts for securities, derivatives, and structured products on Canton DLT, enabling privacy-preserving institutional workflows.",
      "Set up and operate Sereel's Canton validator nodes and deploy DAR packages to the network.",
      "Deploy and operate ZKSync Prividium private chain infrastructure for confidential settlement and compliant DeFi execution.",
      "Build multisig custody infrastructure in Rust covering Bitcoin, EVM chains, Solana, IOTA, and Canton with secure key management and transaction orchestration.",
      "Engineer DeFi integrations with Uniswap, Aave, Morpho, Lido, and Euler, plus ERC-4626 vault contracts for tokenized yield strategies.",
      "Co-authored the Sereel Protocol whitepaper introducing a unified AMM, peer-to-peer lending, and options trading framework for institutional DeFi.",
    ],
  },
  {
    title: "Lead Backend Engineer",
    company: "Riotous Play B.V.",
    url: "https://xmr.gg",
    location: "Remote",
    range: "March 2024 – March 2025",
    bullets: [
      "Built and maintained wallet infrastructure for Bitcoin and Monero, running hot and cold wallets with segregated key custody.",
      "Implemented provably fair game engines in Rust using verifiable randomness, ensuring transparent and auditable outcomes.",
      "Delivered 99.99% API uptime for a high-frequency gaming platform while actively defending against security threats and DDoS attacks.",
      "Designed deployment pipelines with zero-downtime releases, automated rollbacks, and comprehensive monitoring across production environments.",
    ],
  },
  {
    title: "Backend & Infrastructure Engineer",
    company: "Earlier Engineering Roles",
    url: "",
    location: "Kenya / Remote",
    range: "2021 – 2024",
    bullets: [
      { label: "Crafted Systems", url: "https://www.crafted.co.ke/", text: "Architected data infrastructure and analytics pipelines supporting 20+ organizations with DBT, Airflow, Superset, ClickHouse, and PostgreSQL; built custom Rust-based PostgreSQL extensions and maintained highly available CloudNativePG clusters with 99.99% uptime." },
      { label: "Hasibu", url: "https://hasibu.africa/", text: "B2B backend systems serving 300+ businesses with microservices, Kafka event streaming, and automated CI/CD pipelines." },
      { label: "Ohospital Inc.", url: "https://ohospital.health/", text: "Kubernetes cluster management on AWS, HIPAA-compliant infrastructure, and DevOps automation for telehealth platforms." },
      { label: "Clickbanx", url: "", text: "Core fintech API development, third-party payment integrations (M-Pesa, Flutterwave), and security architecture for Pan-African banking." },
      { label: "Monzo Bank", url: "https://monzo.com/", text: "Fraud detection systems and transaction monitoring infrastructure in London, contributing to real-time risk analysis pipelines." },
      { label: "Node operations", url: "", text: "Ran and maintained Ethereum nodes in earlier infrastructure work, ahead of the Canton validator operations at Sereel." },
    ],
  },
];

export const explorations = [
  "https://images.unsplash.com/photo-1518709268805-4e9042af9f23?w=800&q=80&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=800&q=80&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800&q=80&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1620321023374-d1a68fbc720d?w=800&q=80&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1544197150-b99a580bb7a8?w=800&q=80&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1515879218367-8466d910aaa4?w=800&q=80&auto=format&fit=crop",
];

export const stats = [
  { number: "7+", label: "Years Experience" },
  { number: "300+", label: "Businesses Served" },
  { number: "99.99%", label: "Infra Uptime" },
];

export const services = [
  {
    title: "RWA & Tokenized Finance",
    desc: "End-to-end systems for tokenizing real-world assets, from compliance and identity to secondary market plumbing.",
  },
  {
    title: "Onchain Lending & Credit",
    desc: "Lending protocols, credit scoring, and liquidation engines that bring institutional risk management to DeFi.",
  },
  {
    title: "Compliance Infrastructure",
    desc: "KYC/AML flows, transfer restrictions, and reporting pipelines that let institutions move assets onchain safely.",
  },
  {
    title: "AI & Agentic Wallets",
    desc: "Autonomous agents that transact onchain, from intent-based execution to programmable money flows.",
  },
];


// Protocol coverage shown on the home page as one row, no network split.
export const protocols = [
  { name: "Uniswap", icon: "/protocols/uniswap.png" },
  { name: "Aave", icon: "/protocols/aave.png" },
  { name: "Morpho", icon: "/protocols/morpho.png" },
  { name: "Lido", icon: "/protocols/lido.png" },
  { name: "Euler", icon: "/protocols/euler.png" },
  { name: "Kamino", icon: "/protocols/kamino.png" },
  { name: "Jupiter", icon: "/protocols/jupiter.png" },
  { name: "Morpho Midnight", icon: "/protocols/morpho.png" },
];
export const standards = ["ERC-3643", "CMTAT", "ERC-4626", "OnchainID", "DAML"];
export const languages = ["Solidity", "Rust", "DAML", "TypeScript"];

// Three case records for the home page. Each carries an explicit contribution
// line and an attributed outcome; nothing here is a projected or draft figure.
export const selectedWork = [
  {
    id: "tokenization",
    name: "Compliant securities onchain",
    subhead: "Issue digital securities to eligible investors. Keep transfers within the rules.",
    contribution:
      "I build issuance and ownership systems that connect investor verification, transfer restrictions, and asset administration. My work covers the contracts, deployment, and compliance infrastructure behind them.",
    status: "In operation",
    outcome: "Canton validator nodes and DAR deployments, run by me.",
    stack: ["Solidity", "ERC-3643", "CMTAT", "OnchainID", "DAML", "Canton"],
    description:
      "The contracts enforce transfer rules, investor identity, and issuer controls themselves, so a security can change hands onchain and stay within its regulatory limits.",
    technologies: [
      ["ERC-3643 / T-REX", "Permissioned security tokens with transfer controls."],
      ["CMTAT", "Compliant asset-token contract architecture."],
      ["OnchainID", "Investor identity tied to token permissions."],
      ["Canton / DAML", "Privacy-preserving securities and derivatives workflows."],
      ["Canton validators", "Node setup and operation, plus DAR package deployment."],
    ],
    image: {
      src: "/images/work-tokenization.jpg",
      alt: "Engraved London Stock Exchange share certificate from 1920.",
      caption: "Share certificate, London Stock Exchange, 1920.",
    },
  },
  {
    id: "custody",
    name: "Institutional custody",
    subhead: "Define who can move assets, which approvals they need, and how each action is recorded.",
    contribution:
      "I build custody systems that separate key storage from transaction processing, require multiple approvals, and coordinate asset movements across networks. My work includes both active wallets and offline storage.",
    status: "In operation",
    outcome: "Multisig wallet stack in production.",
    stack: ["Rust", "Bitcoin", "Monero", "EVM", "Solana", "IOTA", "Canton"],
    description:
      "The policy layer sits apart from signing, so approvals, limits, and audit trails hold on every chain a desk touches.",
    technologies: [
      ["Rust", "Multisig custody and transaction orchestration."],
      ["Bitcoin / Monero", "Hot and cold wallets, key custody."],
      ["EVM / Solana / IOTA", "Multichain wallet and transaction infrastructure."],
      ["Canton", "Custody for institutional workflows."],
    ],
    image: {
      src: "/images/work-custody-unsplash.jpg",
      alt: "Close-up of a bank vault door and its locking mechanism.",
      caption: "Bank vault.",
    },
  },
  {
    id: "defi",
    name: "Private settlement for digital markets",
    subhead: "Participate in lending and trading while protecting sensitive positions.",
    contribution:
      "I connect lending, liquidity, and yield strategies to institutional settlement workflows. My work covers the financial contracts, transaction infrastructure, and private execution environment.",
    status: "Supporting evidence",
    outcome: "Co-author of an institutional DeFi protocol whitepaper.",
    stack: ["Lending", "Liquidity provision", "Private settlement"],
    evidence: "Read the whitepaper",
    href: "/papers/sereel-protocol.pdf",
    description:
      "Execution on Prividium and DAML keeps positions confidential while the protocol integrations stay composable with the rest of DeFi.",
    technologies: [
      ["Canton / DAML", "Contracts for securities, derivatives, and structured products."],
      ["ZKSync Prividium", "Private chain for confidential settlement."],
      ["Uniswap / Aave / Morpho / Lido / Euler", "Protocol integrations and tokenized yield strategies."],
      ["ERC-4626", "Vaults that hold the yield strategies."],
    ],
    image: {
      src: "/images/work-settlement-unsplash.jpg",
      alt: "Illuminated optical fibers carrying light through a dark network.",
      caption: "Connected infrastructure.",
    },
  },
  {
    id: "agents",
    name: "Agentic wallets",
    subhead: "AI agents that act with money inside the same policy a person would face; work in progress.",
    contribution:
      "Orchestration for AI agents that hold wallets: intent-based execution, programmable money flows, and compliance checks before an agent can sign. Agent SSH, my open-source broker, is the shipped piece of that idea, applied to servers: credentials stay behind the broker, and every action is approved and logged.",
    status: "Open source",
    outcome: "Agent SSH is public today; the wallet orchestration is in progress on the custody stack above.",
    stack: ["Rust", "Agent SSH", "Multisig policy", "Audit logs"],
    evidence: "Open Agent SSH",
    href: "https://aibunny.github.io/agent-ssh/",
    description:
      "The agent gets a narrow, approved surface and full output back; keys and policy stay on the broker side, so an agent can act without ever holding the secret.",
    technologies: [
      ["Agent SSH", "Brokered SSH for AI agents: approvals, full command output, audit trail."],
      ["Intent execution", "Agents express intents; the broker turns approved intents into transactions."],
      ["Policy and compliance", "Spending limits and compliance checks run before signing."],
      ["Multisig custody", "The same signing and audit layer used for institutional custody."],
    ],
    image: {
      src: "/images/work-agents-unsplash.jpg",
      alt: "Robotic hand visualisation against a teal background.",
      caption: "Programmable action.",
    },
  },
];

// Side projects with images, restored from the earlier featured grid.
// Custody and the whitepaper remain main records; the paper cover is a real
// render of page one of the published PDF.
export const sideProjects = [
  {
    id: "ownstate",
    title: "Ownstate",
    kind: "Open source · Rust · MCP",
    text: "An open-source, model-independent memory layer for AI systems. Ownstate gives models and agent fleets governed, provenance-linked context while keeping institutional knowledge portable and self-hostable.",
    img: "/images/ownstate.png",
    alt: "A glass archival volume holding illuminated layers, representing durable institutional memory in Ownstate.",
    url: "https://ownstate.theaibunny.com/",
    repository: "https://github.com/aibunny/ownstate",
    action: "Open project",
    programmingLanguage: "Rust",
    featured: true,
  },
  {
    id: "agent-ssh",
    title: "Agent SSH",
    kind: "Open source · Rust",
    text: "Brokered SSH for AI agents. Credentials stay behind the broker; every command returns full output with approvals and an audit trail.",
    img: "/images/agent-ssh.jpg",
    alt: "Laptop screen showing source code in an editor, the Agent SSH cover image.",
    url: "https://aibunny.github.io/agent-ssh/",
    action: "Open project",
    programmingLanguage: "Rust",
  },
  {
    id: "rusty-telescope",
    title: "Rusty Telescope",
    kind: "Open source · Rust · fork",
    text: "A node exporter for machine metrics: memory, disk, and CPU. Built on Blockops Network's telescope-rust, with my changes on top.",
    img: "/images/rusty-telescope.jpg",
    alt: "Server racks with patch cables and status lights, the Rusty Telescope cover image.",
    url: "https://github.com/aibunny/telescope-rust",
    action: "Open project",
    programmingLanguage: "Rust",
  },
];

// Protocol experience shown under Selected work.
export const protocolWork = [
  { name: "Morpho", icon: "/protocols/morpho.png", text: "Variable-rate lending-market integrations and ERC-4626 vault strategies on EVM." },
  { name: "Morpho Midnight", icon: "/protocols/morpho.png", text: "Fixed-rate, fixed-maturity lending markets, with credit and debt units that settle at maturity." }
];

// Evidence plate for the Institutional DeFi record: page one of the paper.
export const paper = {
  kind: "Whitepaper",
  title: "The Sereel Protocol: Institutional DeFi for Emerging Markets",
  authors: "Lance Davis and Bunny",
  date: "September 2025",
  pages: 36,
  pdf: "/papers/sereel-protocol.pdf",
  filename: "sereel-protocol-whitepaper.pdf",
  dir: "/papers/sereel-protocol",
  source: "https://github.com/0xsereel/whitepaper",
};

export const whitepaperPlate = {
  img: "/images/sereel-whitepaper-cover.jpg",
  alt: "Abstract and introduction from page one of the protocol whitepaper, September 2025.",
  caption: "Protocol whitepaper, page one, September 2025.",
  href: "/papers/sereel-protocol.pdf",
};
